module.exports = __webpack_public_path__ + "static/listitems-d1c7f9b1f1acbf0066dbd6c3d6514180.png";